module.exports = __webpack_public_path__ + "static/media/corpu_doc6.2006857d.jpg";